import React, { useState } from 'react';
import {
  TabbedNavigationContainer,
  TabbedNavigationTitle,
  TabbedNavigationHeader,
  TabbedNavigationHeaderItem,
  TabbedNavigationBody,

} from './TabbedNavigation.style';

import { ITabbedNavigation, ITabbedNavigationBodyItem } from './TabbedNavigation.i';

export const TabbedNavigation = ({ onTabChange, children, title } : ITabbedNavigation) => {
  const children_array = React.Children.toArray(children);
  const tabs = React.Children.map(children, (child) => {
    let ret;

    if(child && child.type === TabbedNavigationBodyItem)
    {
      ret = {
        tabId: child.props.tabId,
        tabLabel: child.props.tabLabel,
      };
    }
    else
    {
      ret = null;
    }

    return ret;
  }).filter((x) => x != null);

  const [activeTab, setActiveTab] = useState( ( tabs.length > 0) ? tabs[0].tabId : null);
  const displayedTab = children_array.filter((child) => (typeof(child) == 'object') && (child.props.tabId === activeTab))[0];

  return (
    <TabbedNavigationContainer>
      {title && <TabbedNavigationTitle><h2>{title}</h2></TabbedNavigationTitle>}
      <TabbedNavigationHeader>
        {tabs.map((tab) =>
          <TabbedNavigationHeaderItem
            active = { tab.tabId === activeTab }
            onPress = {() => {
              setActiveTab(tab.tabId);
              if(onTabChange !== undefined)
              {
                onTabChange(tab.tabId);}
            }
            }
            key = {tab.tabId}
          >
            {tab.tabLabel}
          </TabbedNavigationHeaderItem>)}
      </TabbedNavigationHeader>
      <TabbedNavigationBody>
        {displayedTab}
      </TabbedNavigationBody>
    </TabbedNavigationContainer>
  );
};

export const TabbedNavigationBodyItem = ( props : ITabbedNavigationBodyItem ) => {
  return (
    <div>
      { props.children }
    </div>
  );
};
